<!-- CustomRadioGroup.vue -->
<template>
  <div :class="fieldClass">
    <label v-for="item in formattedOptions" :key="item.value" class="radio-option">
      <input
          type="radio"
          :value="item.value"
          :checked="modelValue === item.value"
           @change="handleChange"
      />
      <span>{{ item.label }}</span>
      <div class="chk-etc-input" v-if="modelValue === 'ETC' && item.value === 'ETC'">
        <input type="text" class="etc" v-model="modalArtWork.etc" placeholder="(직접 입력)">
      </div>
    </label>
  </div>
</template>

<script setup>
import {defineProps, defineEmits, computed, ref} from 'vue'

const props = defineProps({
  modelValue: { type: String, default: '' },
  options: Array,
  fieldClass: { type: String, default: 'field-radio-group' },
  modalArtWork: Object,
})

const emit = defineEmits(['update:modelValue'])
const modalArtWork = ref(props.modalArtWork);

const formattedOptions = computed(() => {
  if (props.options.length > 0 && typeof props.options[0] === 'object') {
    return props.options
  } else {
    return props.options.map(item => ({ value: item, label: item }))
  }
})

const handleChange = (e) => {
  emit('update:modelValue', e.target.value)
}
</script>

<style scoped>
.field-radio-group {
  display: flex;
  flex-wrap: wrap; /* 줄바꿈 허용 */
  column-gap: 12px;
  row-gap: 6px;
  padding: 10px;
}

.radio-option {
  font-size: 15px;
  display: flex;
  align-items: center;
  padding: 4px 0px;
  white-space: nowrap; /* 내부 텍스트 줄바꿈 방지 */
  min-width: 115px;
  position: relative;
}

.radio-option span {
  white-space: nowrap;
}

.radio-option input[type="radio"] {margin-right: 8px; appearance: none; border-radius: 50%; width: 14px; height: 14px; background-color: #fff; border: 2px solid #fff; box-shadow: 0 0 0 1.6px #999; vertical-align: middle; cursor: pointer;}
.radio-option input[type="radio"]:checked {background-color: #151419; border: 2px solid #fff; box-shadow: 0 0 0 1.6px #151419;}
.radio-option input[type="radio"] + label {color: #999; cursor: pointer;}
.radio-option input[type="radio"]:checked + label {color: #151419;}

.radio-option .chk-etc-input{
  position: absolute;
  left: 50px;
  padding: 0px 0px 0px 5px;
  width: 74px;
}
.radio-option .chk-etc-input input[type="text"]{
  width: 100%;
}
</style>
